<template>
    <div class="info-sonars-container">
        <div v-if="sonarCampaignSelected != null ">
          <div class="panel-content-title">
            {{ sonarsCampaignsList[sonarCampaignSelected].name }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].date }}
          </div>
          <div class="panel-content-header">
            Código
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].code }}
          </div>
          <div class="panel-content-header">
            Abstract
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].abstract }}
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].description }}
          </div>
          <div class="panel-content-header">
            Localización
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].location }}
          </div>
          <div class="panel-content-header">
            Objetivo
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].goal }}
          </div>
          <div class="panel-content-header">
            <h5>Datos de la campaña</h5>
            <div class="input-group ">
                <select id="campaign" class="custom-select" v-model="sonarCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in sonarsCampaignsList[sonarCampaignSelected].sonarCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
              </div>
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].sonarCampaignData[sonarCampaignDataSelected].description }}
          </div>
          <div class="panel-content-header">
              Comentarios
          </div>
          <div class="panel-content-line">
            {{ sonarsCampaignsList[sonarCampaignSelected].sonarCampaignData[sonarCampaignDataSelected].comments }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
             {{ sonarsCampaignsList[sonarCampaignSelected].sonarCampaignData[sonarCampaignDataSelected].date }}
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'infoPanelSonars',
    data: function () {
        return {
          sonarCampaignDataSelected: 0
        }
    },
    computed: {
      sonarCampaignSelected: {
          get () { return this.$store.state.mapLayers.layerSonars.sonarCampaignSelected }
      },
      sonarsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsList', {sonarsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsList }
      },
    }
  }
</script>

<style scoped>
  .info-sonars-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-sonar-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
    margin-bottom: 0.8rem;
  }
  .panel-content-header{
    font-size: small;
    line-height: 100%;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }
  .panel-content-title{
    font-weight: 800;
    margin-bottom: 0.5rem;
    color: #00A7E3;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/InfoPanelSonars.vue